import { Injectable } from '@angular/core';
import { CreateProviderAppointmentResponse } from '@models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProviderAppointmentsNotificationService {
  private newAppointment$ =
    new BehaviorSubject<CreateProviderAppointmentResponse | null>(null);
  emit(dto: CreateProviderAppointmentResponse): void {
    this.newAppointment$.next(dto);
  }
  get stream$(): Observable<CreateProviderAppointmentResponse | null> {
    return this.newAppointment$.asObservable();
  }
}
